import comp from "./LockedScreenModal";
export default comp;
